









import { Component, Prop, Vue } from 'vue-property-decorator';
import {
    DualPriceDisplay as DualPriceDisplayData,
    DualPriceEntity,
    resolveDualPriceDisplay
} from '@/filters/dual-price';

@Component
export default class DualPriceDisplay extends Vue {
    @Prop({ required: true }) readonly entity!: DualPriceEntity | null;

    get display(): DualPriceDisplayData {
        return resolveDualPriceDisplay(this.entity);
    }
}
